import React from "react";
import * as ReactMarkdown from "react-markdown";
import { Link } from "react-router-dom";
import { imageUrl, formatDate } from "../util";

const ReportItem = ({ d, company, isAdmin }) => {
  return (
    <div
      className="db near-black block-link bg-white br3 pa3 mv3 ba b--light-gray"
      key={`ss_${d.id}`}
    >
      <p className="f6 b pb2 mb2 near-black bb b--light-gray">
        <b>
          {d.company_name && (
            <>
              <span className="cat-tag mr1">{d.company_name}</span> testing
            </>
          )}{" "}
          <span className="page-tag ml1">{d.headline_tag}</span>
        </b>
      </p>
      <div className="flex flex-wrap old-style">
        <div className="w-100-s w-60-ns pr2">
          <p className="fb near-black mt2 f6 b black-60">
            {d.type === "desktop" && <span>Desktop</span>}
            {d.type === "mobile" && <span>Mobile</span>} &middot;{" "}
            {d.screenshots.length} variants &middot;{" "}
            {d.status === "ended" && <>Test ended</>}
            {d.status === "live" && <>Test is live</>}
          </p>
          <div className="f6 mt3 near-black">
            <ReactMarkdown source={d.description} />
            <p>
              <em>
                Starting {formatDate(d.start_date)}{" "}
                {d.end_date && <span>ending {formatDate(d.end_date)}</span>}
              </em>
            </p>
            {isAdmin && d.notes && (
              <div className="f6 mv2 db ba b--blue pa2 br3">
                <p>
                  <b>Admin-only note:</b> {d.notes}
                </p>
              </div>
            )}
          </div>
          <div className="f6 mt4">
            {d.tags &&
              d.tags.map(tag => (
                <span
                  className="mb2 ttu br2 dib mr2 b tag"
                  key={`${company}_${tag}`}
                >
                  {tag}
                </span>
              ))}
          </div>
        </div>
        <div
          className="mt2 w-100-s w-40-ns pl2-ns pl0 tl"
          style={{ position: "relative" }}
        >
          {isAdmin && (
            <div
              className="f7 ttu b"
              style={{
                position: "absolute",
                top: "-68px",
                right: "0px",
              }}
            >
              <a
                href={`https://dowhatworks.io/home/${d.company}/screenshots/${d.id}`}
                target="_blank"
              >
                See test
              </a>{" "}
              &middot;{" "}
              <a
                href={`https://dowhatworks.io/admin/screenshots/edit/${d.id}?back=${window.location.href}`}
              >
                Edit
              </a>
            </div>
          )}
          <div
            className="img-box dib mr1"
            style={{
              position: "relative",
              backgroundImage: `url(
                                          ${
                                            d.screenshots[0]
                                              ? imageUrl(
                                                  d.screenshots[0].src,
                                                  150,
                                                  175
                                                )
                                              : ""
                                          })`,
            }}
          >
            {d.screenshots[0] && d.screenshots[0].champ && (
              <div className="corner-ribbon">Champ</div>
            )}
          </div>
          <div
            className="img-box dib"
            style={{
              position: "relative",
              backgroundImage: `url(
                                          ${
                                            d.screenshots[1]
                                              ? imageUrl(
                                                  d.screenshots[1].src,
                                                  150,
                                                  175
                                                )
                                              : ""
                                          })`,
            }}
          >
            {d.screenshots[1] && d.screenshots[1].champ && (
              <div className="corner-ribbon-container">
                <div className="corner-ribbon">Champ</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default ReportItem;
